export default "__VITE_ASSET__BBzHzvcU__ 480w, __VITE_ASSET__56watNfl__ 768w, __VITE_ASSET__D6ntsRkg__ 1200w, __VITE_ASSET__BaKyKcDx__ 1600w";